import React from "react";
import { useSelector, useDispatch } from "react-redux";

import {
  Grid,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
} from "@mui/material";

import {
  setTransmissionType,
  setSelectedBillingCodes,
  setShowSwitchUserTypeModal,
} from "app/store/manualUpload/slice/manualUploadSlice";

const PatientInfoToggle = ({
  handlePatientTypeSwitch,
  resetForm,
  resetInOfficeUpload,
  isCrossFacilityClinicUpload,
}) => {
  const { selectedPatient, isExistingPatient, transmissionType } = useSelector(
    (state) => state.manualUpload
  );

  const dispatch = useDispatch();

  return (
    <Grid container className="mb-2">
      <Grid item xs={6}>
        <h3 className="mt-2" data-label="patient-info-patient-type-header">
          Patient Type
        </h3>
        <FormControl>
          <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            defaultValue={isExistingPatient ? "existing" : "new"}
            value={isExistingPatient ? "existing" : "new"}
            onChange={(e) => {
              if (isExistingPatient && !selectedPatient) {
                handlePatientTypeSwitch();
              } else {
                dispatch(setShowSwitchUserTypeModal(true));
              }
            }}
            data-action="patient-info-toggle-patient-type-radio-group"
          >
            <FormControlLabel
              value="existing"
              control={<Radio />}
              label="Existing Patient"
              data-action="patient-info-toggle-existing-patient-radio"
            />

            <FormControlLabel
              value="new"
              control={<Radio />}
              label="New Patient"
              data-action="patient-info-toggle-new-patient-radio"
            />
          </RadioGroup>
        </FormControl>
      </Grid>

      <Grid item xs={6}>
        <h3
          className="mt-2"
          data-label="patient-info-toggle-transmission-type-header"
        >
          Transmission Type
        </h3>
        <FormControl>
          <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            defaultValue="remote"
            value={transmissionType}
            onChange={(e) => {
              resetInOfficeUpload();
              dispatch(setTransmissionType(e.target.value));
              dispatch(setSelectedBillingCodes([]));

              if (isCrossFacilityClinicUpload(selectedPatient?.account)) {
                resetForm();
              }
            }}
            data-action="patient-info-toggle-transmission-type-radio-group"
          >
            <FormControlLabel
              value="remote"
              control={<Radio />}
              label="Remote"
              data-action="patient-info-toggle-remote-radio"
            />
            <FormControlLabel
              value="inOffice"
              control={<Radio />}
              label="In Office"
              data-action="patient-info-toggle-in-office-radio"
            />
          </RadioGroup>
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default PatientInfoToggle;
